import React from 'react';
import './info.sass';

//@ts-ignore
import site from '../../../../media/img/mainInfoSliderImg/webPortfolio.png';
//@ts-ignore
import game from '../../../../media/img/mainInfoSliderImg/game.png';
//@ts-ignore
import bot from '../../../../media/img/mainInfoSliderImg/tgDiscBot.png';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './../slider/slick.css';
import './../slider/slick-theme.css';

export const InfoSliderss = () => {
    const settings =  {
        autoplay: true,
        // centerMode: true,
        dots: true
      };
    return(
        <div className = "mainSliderInfo">
            <Slider { ...settings }>
                <div>
                    <img src = { site } alt="1" />
                </div>
                
                <div>
                    <img src = { bot } alt="1" />
                </div>

                <div>
                    <img src = { game } alt="1" />
                </div>
            </Slider>
    </div> 
    )
}